import {
  SuccessResponse,
  uploadFileRecurring,
  UploadRecurringFileResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import {
  ERROR_MESSAGES_GENERIC_INTERNAL_ERROR,
  ResponseMessage,
  STATUS_CODE_GENERIC_INTERNAL_ERROR,
  STATUS_CODE_NOT_AUTHORIZED,
} from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* uploadRecurringFileRequest(
  self: Self,
  file: FormData,
  merchantID: string
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield uploadFileRecurring(file, merchantID);
    const { data, status } = (response as UploadRecurringFileResponse).data;
    if (data) {
      return Promise.resolve({ data });
    }
    if (status.code === STATUS_CODE_GENERIC_INTERNAL_ERROR) {
      if (status.messages[0] !== ERROR_MESSAGES_GENERIC_INTERNAL_ERROR) {
        return Promise.resolve({ status });
      }
    }
    if (status.code === STATUS_CODE_NOT_AUTHORIZED) {
      handleNotAuthorized(self, response as SuccessResponse);
      return Promise.reject(status.code);
    }
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default uploadRecurringFileRequest;
